import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { getEmployeeDetails, changePassword } from "../../../api/ApiConfig";
import "./ChangePassword.css";
import toast from "react-hot-toast";

export default function ChangePasswordModal({ onClose }) {
  const [smartPassword, setSmartPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState([]);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const employeeResponse = await getEmployeeDetails(); // await the async call
        setEmployeeDetails(employeeResponse);
      } catch (error) {
        console.log("Error fetching employee details:", error);
      }
    };

    fetchEmployeeDetails(); // call the async function
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        current_password: smartPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };

      const response = await changePassword(payload); // Call the API
      toast.success("Password updated successfully!");
      onClose();
    } catch (error) {
      alert("Failed to update password. Please try again.");
    }
  };

  return (
    <div className="modal-overlay mt-5">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Change Password</h2>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="">
            <div className="input-field-global-field">
              <label>User</label>
              <input
                style={{ width: "300px" }}
                type="text"
                placeholder="Enter your name"
                value={employeeDetails.name || ""}
                onChange={(e) => setSmartPassword(e.target.value)}
                disabled
              />
            </div>

            <div className="input-field-global-field password-field">
              <label>Current Password</label>
              <div className="password-input-container">
                <input
                  type={showCurrentPassword ? "text" : "password"}
                  placeholder="Enter your current password"
                  value={smartPassword}
                  onChange={(e) => setSmartPassword(e.target.value)}
                  required
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                >
                  {showCurrentPassword ?  <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
            </div>

            <div className="input-field-global-field password-field">
              <label>New Password</label>
              <div className="password-input-container">
                <input
                  type={showNewPassword ? "text" : "password"}
                  placeholder="Enter your new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              </div>
            </div>

            <div className="input-field-global-field password-field">
              <label>Confirm Password</label>
              <div className="password-input-container">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Enter confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FaEye />: <FaEyeSlash />}
                </span>
              </div>
            </div>

            <div className="mt-2" style={{ paddingLeft: 10 }}>
              <button
                className="save-button"
                type="submit"
                style={{ width: "300px", margin: 0 }}
              >
                Update Password
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
